module.exports = __webpack_public_path__ + "img/header-content.4709631e.png";